import { useSyncExternalStore } from "react";

export const CONSENT_KEY = "cookie-consent";
const CONSENT_EVENT = "atlas-consent-change";
export type Consent = "all" | "essential" | null;

export function getConsent(): Consent {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(CONSENT_KEY);
    return value === "all" || value === "essential" ? value : null;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent() {
  return getConsent() === "all";
}

export function setConsent(value: Exclude<Consent, null>) {
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // Storage unavailable: fail closed rather than start tracking.
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export function subscribeConsent(listener: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === CONSENT_KEY || event.key === null) listener();
  };
  window.addEventListener(CONSENT_EVENT, listener);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(CONSENT_EVENT, listener);
    window.removeEventListener("storage", onStorage);
  };
}

export function useConsent() {
  return useSyncExternalStore(subscribeConsent, getConsent, () => null);
}